<template>
<div class="notice bottom-md js-notice">
  <div class="container">
    <div class="notice__banner max-width-xxxxs bg-light padding-sm radius-md inner-glow shadow-md bg-primary">
      <div class="text-component text-sm margin-bottom-sm">
        <h4 class="color-contrast-lower">{{ $t('cookies_preferences') }}</h4>
        <p class="color-contrast-lower">{{ $t('cookies_text') }} <a :href="privacy_policy" class="color-contrast-lower" target="_blank">{{ $t('privacy_policy') }}</a>.</p>
      </div>
  
      <div class="flex flex-column">
        <button @click="showSettings" class="btn btn--accent text-sm margin-bottom-xxs js-notice__hide-control" v-on:click="allowAll">{{ $t('allow') }}</button>
        <button @click="showSettings" class="btn btn--subtle text-sm margin-bottom-xxs js-notice__hide-control" aria-controls="modal-form">{{ $t('customize') }}</button>
        <button @click="showSettings" class="btn btn--subtle text-sm js-notice__hide-control" v-on:click="revokeAll">{{ $t('deny') }}</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { store } from './../store/index.js'

export default {
  name: 'ConsentPopup',
  data() {
    return {
      privacy_policy: ''
    }
  },
  methods: {
    showSettings() {
      if(typeof window.ampsandConsentShowButton === 'undefined' || window.ampsandConsentShowButton) {
        store.consentButtonShow = true;
      }
    },
    allowAll() {
      store.groups.forEach((group) => {
        group.consent = true;
      });

      localStorage.setItem('ampsandConsent', JSON.stringify(['functional', 'analytics', 'marketing', 'others']));
      localStorage.setItem('ampsandConsentUpdated', Date.now());
      localStorage.setItem('ampsandConsentPreferencesSet', 'true');

      window.dispatchEvent(new Event('onAllowAll'));
      window.dispatchEvent(new Event('onAnalyticsConsentGranted'));
      window.dispatchEvent(new Event('onMarketingConsentGranted'));
      window.dispatchEvent(new Event('onOthersConsentGranted'));
    },
    revokeAll() {
      store.groups.forEach((group) => {
        group.consent = false;
      });

      localStorage.setItem('ampsandConsent', JSON.stringify(['functional']));
      localStorage.setItem('ampsandConsentUpdated', Date.now());
      localStorage.setItem('ampsandConsentPreferencesSet', 'true');

      window.dispatchEvent(new Event('onRevokeAll'));
      window.dispatchEvent(new Event('onAnalyticsConsentRevoked'));
      window.dispatchEvent(new Event('onMarketingConsentRevoked'));
      window.dispatchEvent(new Event('onOthersConsentRevoked'));
    }
  },
  mounted() {
    this.privacy_policy = window.ampsandCookiesPrivacyLink;

    let frontEnd = document.createElement('script');
    frontEnd.setAttribute('src', 'https://cdn.ampersand.company/js/notice.js');
    frontEnd.setAttribute('id', 'notice-js');
    
    document.body.appendChild(frontEnd);
  }
}
</script>

<style lang="scss">
</style>